import {useOpenedStateManager} from '@aboutyou/opened-state-manager';

const FILTER_KEY = 'quick_filter_groupedSize';

export const useQuickFilterSectionSizeGroupedOpenedState = () => {
  return useOpenedStateManager(FILTER_KEY);
};
